import React, { useState } from "react";
import classes from "./Navbar.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Config } from "@config";
import { Avatar, LangSwitcher } from "@components";
import Logo from "@assets/img/logo.png";
import { useTranslation } from "react-i18next";
// import { logout } from "@store/pendingInvoices";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { jwt } from "@services";

export const Navbar = () => {
  const jwToken = jwt();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, loading, isAuthenticated } = useSelector(
    (state) => state.pendingInvoices.pendingInvoices
  );

  const onLogoutHandle = () => {
    const token = localStorage.getItem("token");
    if (token) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
  };

  return (
    <div className={`${classes.navbar}`}>
      <div className={`container`}>
        <div className={`${classes.block}`}>
          <div className={`${classes.logo}`}>
            <NavLink className={`${classes.logoLink}`} to="/">
              <Avatar
                src={Config?.logo?.default}
                className={`${classes.logoImg}`}
              />{" "}
              {t("mainTitle")}
            </NavLink>
          </div>

          <div className={`d-flex align-items-center`}>
            <LangSwitcher />
            {jwToken && (
              <div onClick={onLogoutHandle} className={`${classes.logoutBtn}`}>
                <span className={`icon-logout ${classes.icon}`}></span>{" "}
                {t("Profile.logout")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
